// Warehouse › Order Sheet Rollup: the Order Sheet's Procurement rollup for the active season (options,
// additional requests, Seakeepers) with a Watch-it anti-collision box, on the Warehouse's own page.
// Read-only; the numbers come straight from the order sheet (components/OrderSheetProcurement.tsx).

import { useSeason } from '../season/SeasonContext.js';
import { OrderSheetProcurement } from '../components/OrderSheetProcurement.js';
import { PageHeader } from '../components/ui.js';
import { seasonFolderLabel } from '../features/orderList.js';

export function WarehouseRollup() {
  const { activeSeason } = useSeason();
  return (
    <>
      <PageHeader title={`Order Sheet Rollup - ${seasonFolderLabel(activeSeason)}`} />
      <OrderSheetProcurement season={activeSeason} view="warehouse" />
    </>
  );
}
